var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "columns sc-filter-all__col" }, [
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          {
            class: { "field--required": _vm.fields.warehouseIds.length < 1 },
            attrs: { label: "Transportadora", prop: "logisticProviderIds" }
          },
          [
            _c("sc-lp-taginput", {
              attrs: { active: false, "form-fields": _vm.fields },
              model: {
                value: _vm.fields.logisticProviderIds,
                callback: function($$v) {
                  _vm.$set(_vm.fields, "logisticProviderIds", $$v)
                },
                expression: "fields.logisticProviderIds"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          {
            class: {
              "field--required": _vm.fields.logisticProviderIds.length < 1
            },
            attrs: { label: "Origem", prop: "warehouseIds" }
          },
          [
            _c("sc-warehouse-taginput", {
              attrs: { listUser: true, "form-fields": _vm.fields },
              model: {
                value: _vm.fields.warehouseIds,
                callback: function($$v) {
                  _vm.$set(_vm.fields, "warehouseIds", $$v)
                },
                expression: "fields.warehouseIds"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Status", prop: "localizedStatus" } },
          [
            _c(
              "sc-select",
              {
                attrs: { expanded: "" },
                model: {
                  value: _vm.fields.localizedStatus,
                  callback: function($$v) {
                    _vm.$set(_vm.fields, "localizedStatus", $$v)
                  },
                  expression: "fields.localizedStatus"
                }
              },
              [
                _c("option", { domProps: { value: null } }, [
                  _vm._v("Selecione")
                ]),
                _vm._v(" "),
                _vm._l(_vm.getLocalizedStatus, function(localizedStatus) {
                  return _c(
                    "option",
                    {
                      key: localizedStatus.id,
                      domProps: { value: localizedStatus.id }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(localizedStatus.label) +
                          "\n          "
                      )
                    ]
                  )
                })
              ],
              2
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "column" },
      [
        _c(
          "sc-field",
          { attrs: { label: "Período", prop: "dateRange" } },
          [
            _c("sc-range-date-picker", {
              attrs: {
                format: _vm.formatDate,
                "max-date": _vm.getMaxDate(),
                required: ""
              },
              model: {
                value: _vm.fields.dateRange,
                callback: function($$v) {
                  _vm.$set(_vm.fields, "dateRange", $$v)
                },
                expression: "fields.dateRange"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42957db4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42957db4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-psl/features/list/components/sc-psl-list-filters/ScPslFilterByAll.vue
// module id = null
// module chunks = 